<div *ngIf="seccion === 'L'">
  <div class="grid" *ngIf="carInformacionInicial">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{'LBL_PROCESANDO' | translate }}</span>
    </div>
  </div>
  <div *ngIf="!carInformacionInicial">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6 flex gap-2">
        <button type="button" pButton icon="fa fa-plus" (click)="nuevaPregunta()" *ngIf="menu.agregar" [disabled]="carTabla"
                label="{{ 'CUESTIONARIOPREGUNTA.BTN_NUEVAPREGUNTA' | translate}}"></button>
        <button type="button" pButton icon="fa fa-plus" (click)="importarPregunta()" [disabled]="carTabla"
                label="{{ 'CUESTIONARIOPREGUNTA.BTN_IMPORTARPREGUNTA' | translate}}"></button>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dtpreguntas.filterGlobal($event.target.value, 'contains')"
               name="preCuestionarios">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" #dtpreguntas [loading]="carTabla"
                 [value]="preguntas" selectionMode="single" dataKey="idCuestionarioPregunta"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-index="rowIndex">
            <tr [pSelectableRow]="row">
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-info btn btnDown" icon="fa fa-arrow-down" data-toggle="tooltip"
                          title="{{'BTN_ABAJO' | translate}}" *ngIf="index >=0 && index<preguntas.length-1"
                          pButton (click)="bajar(row)"></button>
                  <button type="button" class="p-button p-button-info btn btnUp" icon="fa fa-arrow-up" data-toggle="tooltip"
                          title="{{'BTN_ARRIBA' | translate}}" pButton *ngIf="index >0"
                          (click)="subir(row)"></button>
                </div>
              </td>
              <td>{{row.pregunta}}</td>
              <td>{{row.tipoPregunta}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                          title="{{'BTN_VISUALIZAR' | translate}}" pButton
                          (click)="ver(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-cog" data-toggle="tooltip"
                          title="{{'CUESTIONARIOPREGUNTA.BTN_CONFIGURAR' | translate}}" pButton *ngIf="cuestionario.indicadorOrdenado"
                          (click)="configurar(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton *ngIf="row.indicadorHabilitado"
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="grid form-footer-buttons" *ngIf="!cuestionario.indicadorOrdenado">
      <div class="form-group col-12">
        <button icon="fa fa-outdent" label="{{ 'CUESTIONARIOPREGUNTA.BTN_FINALIZAR' | translate }}" type="button"
                pButton (click)="finalizarOrdenamiento()"></button>
      </div>
    </div>
  </div>
</div>
<app-cuestionarios-pregunta-banco [cuestionario]="cuestionario" [lisCuestionariosPreguntas]="preguntas" (dismiss)="cambioAcciones($event)"
                                  *ngIf="seccion === 'BP'"></app-cuestionarios-pregunta-banco>
<app-cuestionarios-pregunta-respuesta [cuestionario]="cuestionario" [cuePregunta]="cuePreguntaSeleccionada"
                                      (dismiss)="cambioAcciones($event)" [lisCuestionarioPregunta]="preguntas"
                                      *ngIf="seccion === 'R'"></app-cuestionarios-pregunta-respuesta>
<p-confirmDialog #cd key="pregunta">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>


<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="mosPregunta"
          header="{{ 'CUESTIONARIO.LBL_PREGUNTA'  | translate}} : {{cuePreguntaSeleccionada ? cuePreguntaSeleccionada.pregunta : ''}}"
          [modal]="true">
  <div *ngIf="cuePreguntaSeleccionada">
    <div class="grid">
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIOPREGUNTA.LBL_TIPO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8 "><strong>{{cuePreguntaSeleccionada.tipoPregunta}}</strong></label>
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_PREGUNTA' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{cuePreguntaSeleccionada.pregunta}}</strong></label>
    </div>
    <div class="grid">
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIOPREGUNTA.LBL_FILTRANTE' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{cuePreguntaSeleccionada.indicadorDescartante ? ('LBL_SI' | translate) : ('LBL_NO' |
        translate)}}</strong></label>
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{cuePreguntaSeleccionada.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
        translate)}}</strong></label>
    </div>
    <div class="grid">
      <div class="col-12 lg:col-12 md:col-12">
        <p-table [columns]="colRespuestas"
                 [value]="cuePreguntaSeleccionada.respuestas" selectionMode="single" dataKey="idCuestionarioPreguntaRespuesta"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.respuesta}}</td>
              <td>{{row.preguntaDepende}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorCorrecta" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
                pButton (click)="cerrar()"></button>
      </div>
    </div>
  </div>
</p-dialog>
